// extracted by mini-css-extract-plugin
module.exports = {"success":"notifications_success__16gip","progressBar":"notifications_progressBar__1WhlL"};